const API_BASE = (process.env.REACT_APP_SERVER_BASE_URL || "http://localhost:3001").replace(/\/$/, "");

// Our server redirects /photos/<name> to Google's keyless photo URL. `thumbnail` (key inside) is only
// a fallback for a response from a server that predates `photo`.
export function shopPhotoUrl(shop, width = 400) {
  if (shop?.photo) return `${API_BASE}/photos/${shop.photo}?w=${width}`;
  if (!shop?.thumbnail) return null;
  return `https://places.googleapis.com/v1/${shop.thumbnail}`.replace("maxWidthPx=400", `maxWidthPx=${width}`);
}
